import { PayloadAction, createReducer, combineReducers, Reducer } from "@reduxjs/toolkit";

import errorActions from "./error.actions";

export interface SocketError {
  message?: string;
}

export interface NetworkError {
  status: number;

  statusText: string;

  details: unknown;
}

export interface LocalError {
  message: string;

  details: unknown;
}

export interface ErrorStore {
  networkError: NetworkError | null;

  localError: LocalError | null;
}

export const errorReducer: Reducer<ErrorStore> = combineReducers({
  networkError: createReducer<NetworkError | null>(null, builder =>
    builder
      .addCase(
        errorActions.setNetworkErrorAction,
        (_: NetworkError | null, { payload }: PayloadAction<NetworkError>) => payload
      )
      .addCase(errorActions.resetErrorAction, (_: NetworkError | null) => null)
  ),
  localError: createReducer<LocalError | null>(null, builder => {
    builder
      .addCase(
        errorActions.setLocalErrorAction,
        (_: LocalError | null, { payload }: PayloadAction<LocalError>) => payload
      )
      .addCase(errorActions.resetErrorAction, (_: LocalError | null) => null);
  })
});
